import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAssetType } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IAssetTypeUpdateDTO } from '@interfaces/platform/dto/manageAssetTypesDTO';

import { ESnackbarTypes } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { MANAGE_ASSET_TYPES, UPDATE_ASSET_TYPE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAssetType = () => {
	const dispatch = useAppDispatch();

	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateAssetType,
		isLoading: isLoadingUpdateAssetType,
	} = useMutation<IAssetTypeUpdateDTO>({
		mutationKey: [UPDATE_ASSET_TYPE],
		mutationFn: updateAssetType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetTypeUpdated,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleUpdateAssetType,
		isLoadingUpdateAssetType,
	};
};
